"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    COMMON_APP_PDF: 'Common App PDF',
    COMMON_APP_ESSAY: 'Common App Essay',
    UC_PDF: 'UC PDF',
    UC_ESSAY: 'UC Essay',
    UCAS_PDF: 'UCAS PDF',
    UCAS_PERSONAL_STATEMENT: 'UCAS Personal Statement',
    EU_APP_ESSAY: 'EU Application Essay',
    EU_CV_PDF: 'EU CV PDF',
    OTHER: 'Other Essay',
};
//# sourceMappingURL=appEssayTypes.js.map